import {combineReducers} from 'redux';
import users from './user.reducer';

const usersReducer = combineReducers({
    users
});

export default usersReducer;